import React, { useState } from "react";
import { API, graphqlOperation, Storage } from "aws-amplify";
import { deleteFile } from "../../../graphql/mutations";

import {
  useListContext,
  useRefresh,
  useNotify,
  // useUnselectAll,
  Button,
} from "react-admin";

import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";

import { DeleteIcon } from "../../../components/common/iconography";
import { logError } from "../../../utils/appUtils";

const useStyles = makeStyles(
  (theme) => ({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "RaDeleteWithConfirmButton" }
);

export const BulkDeepDeleteButton = ({ className, ...props }) => {
  const classes = useStyles();
  const notify = useNotify();
  const refresh = useRefresh();

  const {
    // fetched data
    data, // an id-based dictionary of the list data, e.g. { 123: { id: 123, title: 'hello world' }, 456: { ... } }
    selectedIds, // an array listing the ids of the selected rows, e.g. [123, 456]
    onUnselectItems,
  } = useListContext();

  const [loading, setLoading] = useState(false);
  const deleteFiles = async () => {
    try {
      setLoading(true);
      debugger;

      await Promise.allSettled(
        selectedIds.map((fileId) => {
          const record = data[fileId];
          if (record) return Storage.remove(record.file.key);
        })
      );

      await Promise.all(
        selectedIds.map((fileId) => {
          return API.graphql(
            graphqlOperation(deleteFile, { input: { id: fileId } })
          );
        })
      );

      notify("Files deleted successfully.", "info");
      onUnselectItems();
      refresh();
    } catch (error) {
      logError("files:BulkDeepDeleteButton:deleteFiles", error, notify);
    }

    setLoading(false);
  };

  const handleUpdate = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    deleteFiles();
  };

  return (
    <Button
      label="Delete"
      disabled={loading}
      onClick={handleUpdate}
      className={classnames(
        "ra-delete-button",
        classes.deleteButton,
        className
      )}
    >
      <DeleteIcon />
    </Button>
  );
};
